

























import { Component, Vue, Watch } from 'vue-property-decorator';
import authProvider from '@/utility/authProvider';
import Loading from 'vue-loading-overlay';
import { DATA } from '@/config/data';
import { APP_CONFIG } from '@/config/app-config';
import { BillOfLadingModel } from '@/models/bill-of-lading';
import ListPackage from './components/ListPackage.vue';
import ReceiverInfo from './components/ReceiverInfo.vue';
import formatNumber from '@/shared/filters/format-number';
import authService from '@/services/auth-services';
import receiptServices from '@/services/receipt-services';

@Component({
    components: {
        ListPackage,
        ReceiverInfo,
        Loading
    }
})
export default class DetailReceipt extends Vue {
    get receiptId() {
        return this.$route.params.id;
    }
    private listPackage: BillOfLadingModel[] = [];
    private isLoading = false;
    private customerInfo: any = {};
    private receipt: any = {};

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    @Watch('receiptId', { immediate: true, deep: true })
    private async watchReceiptId() {
        if (this.receiptId) {
            this.initComponent();
        }
    }

    private async initComponent() {
        await this.loadData();
        await this.getCustomersInfo();
    }

    private async getCustomersInfo() {
        const result = await authService.customersInfo(this.userInfo.userId);
        if(result && result.status === 200) {
            this.customerInfo = result.data.data || {};
            (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
        }
    }

    private async loadData() {
        this.isLoading = true;
        const result = await receiptServices.getDetail(this.receiptId);
        this.isLoading = false;
        if (result && result.data && result.data.status === 200) {
            const tmpList: BillOfLadingModel[] = [];
            for (const item of result.data.data.ListPackage) {
                const bill = new BillOfLadingModel();
                bill.id = item.ID;
                bill.createdBy = item.CreatedBy;
                bill.createdDate = item.CreatedDate;
                bill.modifiedBy = item.ModifiedBy;
                bill.modifiedDate = item.ModifiedDate;
                bill.orderCodeId = item.OrderCodeID;
                bill.orderId = item.OrderID;
                bill.transactionCode = item.TransactionCode;
                bill.productName = item.ProductName;
                bill.productAmount = item.ProductAmount;
                bill.numberOfPack = item.NumberOfPack;
                bill.realNumberOfPack = item.RealNumberOfPack;
                bill.productNumber = item.ProductNumber;
                bill.feeType = item.FeeType;
                bill.packageType = item.PackageType;
                bill.productType = item.ProductType;
                bill.totalAmount = item.TotalAmount;
                bill.status = item.Status;
                bill.exchangeRate = item.ExchangeRate;
                bill.feeShipVND = item.FeeShipVND;
                bill.weightPrice = item.WeightPrice;
                bill.volumePrice = item.VolumePrice;
                bill.length = item.Length;
                bill.width = item.Width;
                bill.height = item.Height;
                bill.statusDetail = DATA.billOfLadingStatus.find(x => x.value === item.Status) || { value: 0, name: 'Khác', color: '#3b4354' };
                bill.uId = item.UID;
                bill.userName = item.Username;
                bill.weight = item.Weight > 0 ? `${formatNumber(item.Weight, '0,0.[0000]')}` : '';
                bill.weightByVolume = item.WeightByVolume > 0 ? `${formatNumber(item.WeightByVolume, '0,0.[0000]')}` : '';
                bill.volume = item.Volume;

                tmpList.push(bill);
            }
            this.listPackage = tmpList;
            this.receipt = result.data.data;
        }
    }
}
